import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  DocumentData
} from '@angular/fire/firestore';
import { Observable} from 'rxjs';

import { UserProfile } from '../model/userProfile.model';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  userProfile: UserProfile = new UserProfile;

  constructor(
    private db: AngularFirestore,
  ) { }
  // TODO
  // addUserProfile(fbaUID: string, firstname: string, email?: string, lastname?: string, phone?: string): Observable<any> {
  //   let props = {
  //     uId: fbaUID,
  //     first: firstname,
  //     last: lastname,
  //     email: email,
  //     phonePrimary: phone,
  //     registered: Date.now(),
  //     status: 'active'
  //   };

  //   const docRef = this.db.collection('userProfiles').ref.doc(fbaUID);
  //   docRef.set(props)
  //     .then((res: any) => console.log('new user sergice => ', res));
  // }

  getUserProfile(uid: string): Promise<DocumentData> {
    const docRef = this.db.collection('userProfiles').doc(uid);

    return docRef.ref.get()
      .then((doc: DocumentData) => {
        if (doc.exists) {
          return doc.data();
        }
      })
      .catch((error) => { });
  }

  getUserProfileSubscrible(uid: string): Observable<any> {
    return this.db.collection('userProfiles').doc(uid).valueChanges();
  }

  getUIDfromEmail(email: string): Promise<string> {
    return this.db.collection('userProfiles').ref
      .where('email', '==', email)
      .limit(1)
      .get()
      .then(function(qs) {
        return qs.docs[0] ? qs.docs[0].id : null;
      });
  }

  getUserProfiles(): Observable<any> {
    return this.db.collection('userProfiles', ref => ref)
      .valueChanges();
  }

  getUserName(uId: string): Promise<string | void> {
    return this.db.doc(`userProfiles/${uId}`).ref
      .get()
      .then((ds) => {
        return ds.data() ? (ds.data().first + ' ' + ds.data().last) : '';
      });
  }

  addEmptyUserProfile(fbUID: string, email?, first?, last?): Promise<any> {
    const userProfile = {
      uId: fbUID,
      email,
      first,
      last,
      status: 'active',
      hidden: false,
      locationOn: false,
      registered: Date.now()
    };

    const docRef = this.db.collection('userProfiles').ref.doc(fbUID);
    return docRef.set(userProfile)
      .then((res: any) => {
        return userProfile;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateUserProfile(userProfile: UserProfile, uid: string): Promise<DocumentData | void> {
    userProfile.uId = uid;
    const docRef = this.db.collection('userProfiles').doc(uid);

    // return docRef.update(userProfile);
    return docRef.set(userProfile, { merge: true });
  }

  updateUserProfileStatus(uid: string, reactivate: boolean = false): Promise<DocumentData | void> {
    const userDocRef = this.db.collection('userProfiles').doc(uid).ref;
    const raceDocRef = this.db.collection('userRaceProfiles').doc(uid).ref;

    return this.db.firestore.runTransaction(transaction => {
      return Promise.all([
        transaction.get(userDocRef),
        transaction.get(raceDocRef)
      ])
        .then(docs => {
          const userDoc = docs[0];
          const raceDoc = docs[1];

          if (!userDoc.exists) {
            throw new Error('UserProfile does not exist!');
          }
          transaction.update(userDocRef, {
            hidden: !reactivate,
            status: reactivate ? 'active' : 'disabled'
          });

          if (!raceDoc.exists) {
            throw new Error('RaceProfile does not exist!');
          }
          transaction.update(raceDocRef, {
            hidden: !reactivate
          });
        });
    });
  }

  isUserActive(uId: string): Promise<boolean | void> {
    return this.db.doc(`userProfiles/${uId}`).ref
      .get()
      .then((ds) => {
        // return true if the status is not present or is 'active'
        return (!ds.data().status || ds.data().status === 'active');
      })
      .catch(res => {
        // if no user, return false
        return true;
      });
  }

  isUserAckWelcome(uId: string): Promise<boolean | void> {
    return this.db.doc(`userProfiles/${uId}`).ref
      .get()
      .then((ds) => {
        // return true if the userAckWelcome is present and > 0
        if (ds.data().userAckWelcome && ds.data().userAckWelcome > 0) {
          return true;
        } else {
          return false;
        }
      })
      .catch(res => {
        // if no user, return false
        return false;
      });
  }

  userAckWelcome(uId: string): Promise<DocumentData | void> {
    const docRef = this.db.collection('userProfiles').doc(uId);

    // return docRef.update(userProfile);
    return docRef.set({ userAckWelcome: Date.now() }, { merge: true });
  }
}
